//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";


export const PatientMenu = createAsyncThunk(
  "PatientMenu",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingPatientMenu(""));
      const response = await UsePortalApi(
        `Patient/PatientMenu`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
        response[0].hasOwnProperty('entry') ? dispatch(gettingPatientMenuSuccess(response[0].entry)) : dispatch(null)
      } else {
        dispatch(
          gettingPatientMenuFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingPatientMenuFailed(error));
    }
  }
);
const PatientMenuSlice = createSlice({
  name: "PatientMenu",
  initialState: {
    ProxyMenu: null,
    isLoadingMenu: false,
    errorMenu: false,
  },
  reducers: {
    gettingPatientMenu: (state, action) => {
      state.ProxyMenu = null;
      state.isLoadingMenu = true;
      state.errorMenu = false;
    },
    gettingPatientMenuSuccess: (state, action) => {
      state.ProxyMenu = action.payload;
      state.isLoadingMenu = false;
      state.errorMenu = false;
    },
    gettingPatientMenuFailed: (state, action) => {
      state.ProxyMenu = null;
      state.isLoadingMenu = false;
      state.errorMenu = true;
    },
    gettingPatientMenuClear: (state, action) => {
      state.ProxyMenu = null;
      state.isLoadingMenu = false;
      state.errorMenu = false;
    },
  },
});
export const {
  gettingPatientMenu,
  gettingPatientMenuSuccess,
  gettingPatientMenuFailed,
  gettingPatientMenuClear,
} = PatientMenuSlice.actions;
export default PatientMenuSlice.reducer;
